import { Skeleton, type SkeletonProps, useTheme } from "@mui/material";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";

interface SabSkeletonProps extends SkeletonProps {
	maxWidth?: string | number;
	borderRadius?: string | number;
}

export const SabSkeleton = ({
	maxWidth,
	borderRadius,
	sx,
	...props
}: SabSkeletonProps) => {
	const theme = useTheme();
	const pilotGoal = useGoalsRightOptional();
	const greyScale = pilotGoal
		? theme.palette.grey
		: theme.palette.deprecated.grey;

	return (
		<Skeleton
			{...props}
			sx={[
				{ backgroundColor: greyScale[100], maxWidth, borderRadius },
				...(Array.isArray(sx) ? sx : sx ? [sx] : []),
			]}
		/>
	);
};
